import * as Locale from './locale';
import {ViewTypes} from './ui';

/**
 * Global state as defined for the components must follow this specific
 * interface.
 */
export interface GlobalState {
    location: Location | Object;
    ui: any;
    data: any;
};

/**
 * The beginning global state on page initialisation
 */
export var InitialState: GlobalState = {
    location: {},
    ui: {
        // global page loading for blocking calls (e.g. change language)
        loading: true,
        loadingMessage: '',
        // feedback messages, errors, success, etc.
        messages: [],
        // UI specific to accounts
        accounts: {
            contactModal: {
                validationErrors: null
            }
        },
        // UI specific to viewing premises
        premises: {
            viewType: ViewTypes.Card,
            selectedCountry: null,
            selectedRegion: null,
            registration: {
                // NB: validation errors MUST be null if there are no
                // server-side validation errors, otherwise form has issues
                validationErrors: null,
                status: {loading: true}
            },
            iccid_registration: {
                status: {submitting: false}
            }
        },
        premisesUnits: {
            loading: true,
        },
        geo: {
            loading: true
        },
        sensors:{
            readingsLoading: true,
            individualSensorsLoading: {}
        },
        cabinets: {
            readingsFetching: false
        },
        timers: {}
    },
    data: {
        // language state - default to no languages
        language: Locale.LANG_NONE,
        // user information e.g. username, email, etc.
        user: {
            features: {}
        },
        // function for translating text
        textForKey: () => (''),
        // all premises being listed by user currently
        premises: {
            results: [],
            count: 0
        },
        // All possible cabinets to be exported
        premisesUnits: [],
        units: {
            results: [],
            count: 0
        },
        //All sensors for that page
        sensors: {},
        // all gateways accessible for the current user
        gateways: {
            map: {}
        },
        // countries in the system
        countries: {
            sortedByName: [],
            data: {},
        },
        // country regions in the system
        regions: {
            data: {},
            sortedByName: [],
            byCountry: {},
        },
        // general summary information
        summary: {
            alarms: {
                // global uncleared alarm count for user's units
                uncleared_count: 0
            }
        },
        // list of current units for calibration and the associated statuses
        calibration: {
            units: []
        }
    }
};
